<div class="flex flex-col items-center error-msg p-12">
  <div class="flex flex-row">
      <div class="icon-oval mr-16">
      <mat-icon svgIcon="highlight_off" class="icon-md"></mat-icon>
      </div>
      <div>{{title ? title : ('ERRORS.SERVICE_AVAILABILITY' | transloco)}}</div>
  </div>
  <div class="fw-400">
    {{message}}
  </div>
</div>
  